import { render, staticRenderFns } from "./IconMagicStick.vue?vue&type=template&id=8569337c&"
import script from "./IconMagicStick.vue?vue&type=script&lang=js&"
export * from "./IconMagicStick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports